import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

import withRouter from "components/_Common/withRouter";
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';

// import images
import schorLogo from "assets/images/schor-logo.png";
import logo from "assets/images/logo.svg";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";

const Starter = props => {
    const navigate = useNavigate();
    const callback = useCallback();
    //meta title

    document.title = "Institute on Governance - Admin & Dashboard";
    const loginSelect = (e) => {
        if (e?.target?.value === 'raters') {
            localStorage.setItem("number", 60)
            // window.location.href = '/rater/login'
            navigate('/rater/login', { state: { loginType: e?.target?.value } });

        } else if (e?.target?.value === 'participants') {
            localStorage.setItem("number", 40)
            // window.location.href = '/participant/login'
            navigate('/participant/login', { state: { loginType: e?.target?.value } });

        } else {
            localStorage.setItem("number", 20)
            // window.location.href = '/admin/login'
            navigate('/admin/login', { state: { loginType: e?.target?.value } });

        }
    }

    useEffect(() => {
        setTimeout(() => {
            localStorage.setItem("i18nextLng", 'EN')
            localStorage.setItem("language_id", '1')
            localStorage.setItem("I18N_LANGUAGE", 'EN')
            i18n.changeLanguage('EN')
        }, 1);
    }, [])
    return (
        <React.Fragment>
            <div className="account-pages my-5">
                <Container>
                    <div className="main-form-wrapper" style={{ "border": "1px solid #ccc", "padding": "50px 30px", "borderRadius": "20px", 'maxWidth': "800px", "margin": "auto", "background": " #fff" }}>
                        <Row className="justify-content-center">
                            <Col md={12} lg={10} xl={8}>
                                <div className="header container">
                                    <div className="logo text-center">  <img src={schorLogo} alt="" className="img-fluid" /></div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={12} lg={10} xl={8}>
                                <Card className="overflow-hidden">
                                    <CardBody className="pt-0 d-block">
                                        <div>
                                            <Link to="/" className="logo-light-element">
                                                <div className="avatar-md profile-user-wid mb-4">
                                                    <span className="avatar-title rounded-circle bg-light">
                                                        <img
                                                            src={logo}
                                                            alt=""
                                                            className="rounded-circle"
                                                            height="34"
                                                        />
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="p-2 d-grid">

                                            <div className="mt-0 text-center">
                                                <h5 className="font-size-22 mb-3 mt-2">Welcome to Institute on Governance !</h5>
                                            </div>
                                        </div>
                                        <div className="drop_down m-auto text-center w-100">

                                            <select id="id_select" className="selectpicker bla bla bli w-100" onChange={loginSelect} style={{ "maxWidth": "300px" }} >

                                                <option value="">Select panel</option>

                                                <option value="admin">Admin</option>

                                                <option value="participants">Participant</option>

                                                <option value="raters">Rater</option>

                                            </select>

                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-1 text-center ">
                                    <p className="m-0 text-center">
                                        © {new Date().getFullYear()} Institute on Governance. {props.t("Crafted with")}{" "}
                                        <i className="mdi mdi-heart text-danger" /> {props.t("by Suffescom")}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div >
        </React.Fragment >
    );
};

Starter.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(Starter);